import React from "react";
import SkeletonElement from "./BasicSkeleton/SkeletonElement";
import SkeletonAnimation from "./BasicSkeleton/SkeletonAnimation";

const WalletSkeleton = () => {
  return (
    <div className="wallet-skeleton ">
      <div className="skeleton-card large m-0 ">

        <div className="d-flex flex-column flex-sm-row  justify-content-between wallet-text align-items-sm-center me-xl-5 pe-xl-5 m-auto">
          <div className="m-auto mb-0">
            <SkeletonElement type="title" style={{ "width": "50px" }} />
          </div>
        </div>


        <div className="flex-fill  d-flex flex-column flex-lg-row align-items-lg-center mb-3 mx-2 mt-3">
          {/* <div className="d-flex  flex-sm-row align-items-sm-center mb-3 me-lg-3 me-xl-5">
            <SkeletonElement type="avatar" />
            <div className="ms-2 ms-sm-3 owner-key align-self-center">
              <SkeletonElement type="title" />
              <SkeletonElement type="text" />
            </div>
          </div> */}
          <div className="d-flex flex-column flex-sm-row  justify-content-between wallet-text align-items-sm-center me-xl-5 pe-xl-5">
            <div className="ms-lg-5 mb-0">
              <SkeletonElement type="text" style={{ "width": "20px" }} />
              <SkeletonElement type="text" />
              <SkeletonElement type="text" style={{ "width": "10px" }} />

            </div>
          </div>

          <div className="d-flex flex-column flex-sm-row  justify-content-between wallet-text align-items-sm-center me-xl-5 pe-xl-5">
            <div className="ms-lg-5 mb-0">
              <SkeletonElement type="text" style={{ "width": "20px" }} />
              <SkeletonElement type="text" />
              <SkeletonElement type="text" style={{ "width": "10px" }} />

            </div>
          </div>

          <div className="d-flex flex-column flex-sm-row  justify-content-between wallet-text align-items-sm-center me-xl-5 pe-xl-5">
            <div className="ms-lg-5 mb-0">
              <SkeletonElement type="text" style={{ "width": "20px" }} />
              <SkeletonElement type="text" />
              <SkeletonElement type="text" style={{ "width": "10px" }} />

            </div>
          </div>


          <div className="d-flex flex-column flex-sm-row  justify-content-between wallet-text align-items-sm-center me-xl-5 pe-xl-5">
            <div className="ms-lg-5 mb-0">
              <SkeletonElement type="text" style={{ "width": "20px" }} />
              <SkeletonElement type="text" />
              <SkeletonElement type="text" style={{ "width": "10px" }} />

            </div>
          </div>
        </div>
        <div className="flex-fill">
          <div className="wallet-skeleton-gangsta ">
            <div className="d-flex ms-0 ms-lg-2 align-items-center">
              <SkeletonElement type="title" />
              <SkeletonElement type="svg ms-3" />
            </div>
            <div className="mx-auto mt-2 wallet-card-container d-flex justify-content-center justify-content-sm-start flex-wrap">
              <SkeletonElement type="img" />
              <SkeletonElement type="img" />
              <SkeletonElement type="img" />
              <SkeletonElement type="img" />
            </div>
          </div>
        </div>
        <SkeletonAnimation />
      </div>
    </div>
  );
};

export default WalletSkeleton;
